import React from "react";
import { Grid, TextField, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import "@ckeditor/ckeditor5-build-classic/build/translations/fa";
import { useSelector, useDispatch } from "react-redux";
import "@ckeditor/ckeditor5-build-classic/build/translations/fa";
import { setFormSettings } from "redux/actions/FormBuilder";
import CheckBox from "@jumbo/Dashboards/Banner/CheckBox";

const useStyles = makeStyles((theme) => ({
  textFieldLabel: {
    color: theme.palette.primary.main,
    marginBottom: "16px",
    fontWeight: "bold",
  },
  formControl: {
    width: "100%",
  },
}));

const ExamSettings = () => {
  const classes = useStyles();

  const { formSettings } = useSelector(({ formBuilder }) => formBuilder);
  const dispatch = useDispatch();

  const {
    maxQuestions,
    durationEnabled,
    durationMinutes,
  } = formSettings;

  return (
    <>
      <Grid item xs={12}>
      <Grid item xs={12} md={7}>
        <Typography className={classes.textFieldLabel}>تعداد سوال های کاربر</Typography>
        <TextField
          id="titleField"
          label="تعداد سوال های کاربر"
          variant="outlined"
          type="number"
          className={classes.formControl}
          value={maxQuestions}
          inputProps={{ min: 1 }}
          onChange={(e) =>
            dispatch(
              setFormSettings({ ...formSettings, maxQuestions: e.target.value })
            )
          }
          onWheel={(e) => e.target.blur()}
        />
      </Grid>
      </Grid>

      <Grid item xs={12}>
        <CheckBox
          name={"durationEnabled"}
          title={"محدودیت زمان پاسخگویی"}
          value={durationEnabled}
          handleChange={() =>
            dispatch(
              setFormSettings({
                ...formSettings,
                durationEnabled: !durationEnabled,
              })
            )
          }
        />
      </Grid>

      {durationEnabled && (
        <Grid item xs={12} md={7}>
          <Typography className={classes.textFieldLabel}>
            مدت زمان پاسخگویی (دقیقه)
          </Typography>
          <TextField
            id="durationMinutesField"
            label="مدت زمان پاسخگویی (دقیقه)"
            variant="outlined"
            type="number"
            className={classes.formControl}
            value={durationMinutes}
            inputProps={{ min: 1 }}
            onChange={(e) =>
              dispatch(
                setFormSettings({
                  ...formSettings,
                  durationMinutes: e.target.value,
                })
              )
            }
            onWheel={(e) => e.target.blur()}
          />
        </Grid>
      )}
    </>
  );
};

export default ExamSettings
